const colors = {
  gray: '#929393',
  lightGray: '#C9C9C9',
  lightLightGray: '#e5e5e5',
  yellowLighter: '#FFFFBA',
  darkGray: '#565656',
  red: '#F35C3C',
  blue: '#02A5FB',
  cyen: '#58c9c1',
  charcoal: '#595959',
  blueLighter: '#8294d6',
  lightBlue: '#6F7DB8',
  blueButton: '#0454A1',
  pink: '#ef5085',
  grayedOutButton: '#acb6bf',
  green: '#22D190',
  purpleLighter2: '#9EB5FC',
  shopifyColor1: '#212645'
};
export default colors;